import { GetRunFlowTaskSubscriptionFlowRequest,GetRunFlowTaskSubscriptionFlowResult } from '~src/flow/serverApi/requests/GetRunFlowTaskSubscriptionFlowRequest';
import WebHttpClient from '~src/httpClient/WebHttpClient';

import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';
import { DeleteRunFlowTasksRequest } from '../serverApi/requests/DeleteRunFlowTasksRequest';
import { GetRunFlowTasksRequest } from '../serverApi/requests/GetRunFlowTasksRequest';
import { ResumeRunFlowTasksRequest } from '../serverApi/requests/ResumeRunFlowTasksRequest';
import { RunFlowTasksRequest } from '../serverApi/requests/RunFlowTasksRequest';
import { SetRunFlowTaskOutputStepsRequest } from '../serverApi/requests/SetRunFlowTaskOutputStepsRequest';
import { SetRunFlowTasksPriorityRequest } from '../serverApi/requests/SetRunFlowTasksPriorityRequest';
import { SetRunFlowTasksScheduleRequest } from '../serverApi/requests/SetRunFlowTasksScheduleRequest';
import { IFlowRunSpecOutputStepViewModel } from '../serverApi/types/IFlowRunSpecOutputStepViewModel';
import { FlowParameterParams } from '../types/FlowParameters';

export class RunFlowTasksResource {

  private fetcher = new WebClientListResourceFetcher(GetRunFlowTasksRequest, ServerApiMapper.runFlowTasks);

  public MAX_PRIORITY = 100;
  public MIN_PRIORITY = 1;

  public all(): ResourceQuery<RunFlowTaskInfo> {
    return new ResourceQuery(this.fetcher);
  }

  public del(ids: string[]): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteRunFlowTasksRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public run(ids: string[]): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new RunFlowTasksRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  public setPriority(ids: string[], priority: number): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetRunFlowTasksPriorityRequest(idsBlock, priority)),
      ResultHelper.combineResults);
  }

  public setSchedule(ids: string[], scheduleId: string): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetRunFlowTasksScheduleRequest(idsBlock, scheduleId)),
      ResultHelper.combineResults);
  }

  public getSubscriptionFlow(taskId: string): Promise<GetRunFlowTaskSubscriptionFlowResult> {
    return WebHttpClient.sendRequest(new GetRunFlowTaskSubscriptionFlowRequest(taskId))
      .then((result: GetRunFlowTaskSubscriptionFlowResult) => result);
  }

  public setOutputSteps(
    taskId: string,
    runAllOutputs: boolean,
    isRunAllIncremental: boolean,
    ids: string[],
    flowRunSpecOutputStepParams: IFlowRunSpecOutputStepViewModel[],
    parameterParams?: FlowParameterParams[],
  ): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestAndDelay(
      new SetRunFlowTaskOutputStepsRequest({
        id: taskId,
        runAllOutputs: runAllOutputs,
        isRunAllIncremental,
        flowOutputStepIds: ids,
        flowRunSpecOutputStepParams,
        parameterParams: parameterParams,
      })
    );
  }

  public resume(ids: string[]): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new ResumeRunFlowTasksRequest(idsBlock)),
      ResultHelper.combineResults);
  }
}

export const RunFlowTasks = new RunFlowTasksResource();
